module.exports = __webpack_public_path__ + "static/media/qa-answer.7c8e1503.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/OnboardingDemo/assets/qa-answer.png
// module id = 498
// module chunks = 0